import { Body1, Body1Strong } from '@fluentui/react-components';
import { TASK_PRIORITY_LABELS } from '../constants';
import { ETaskPriority } from '../types';

type TProps = { priority: ETaskPriority; variant?: 'default' | 'compact' };
const TaskPriorityLabel = ({ priority, variant = 'default' }: TProps) => {
  const compact = variant === 'compact';
  const Text = compact ? Body1 : Body1Strong;
  if (priority === ETaskPriority.NONE) return <Text className={compact ? 'text-neutralFg-3' : undefined}>-</Text>;
  return <Text>{TASK_PRIORITY_LABELS[priority]}</Text>;
};
export default TaskPriorityLabel;
